import { render, staticRenderFns } from "./genelamacli.vue?vue&type=template&id=bb9a7c98&"
import script from "./genelamacli.vue?vue&type=script&lang=js&"
export * from "./genelamacli.vue?vue&type=script&lang=js&"
import style0 from "./genelamacli.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports